export const messages = {
  en: {
    shopSmsDetail: {
      queryCondition: 'Query Conditions',
      enterPhoneNumber: 'Please enter phone number',
      query: 'Query',
      sendRecords: 'Send Records',
      back: 'Back',
      detailId: 'Detail ID',
      shopName: 'Shop Name',
      smsContent: 'SMS Content',
      phoneNumber: 'Phone Number',
      sendTime: 'Send Time',
      phonePlaceholder: 'Please enter phone number'
    }
  },
  zh: {
    shopSmsDetail: {
      queryCondition: '查询条件',
      enterPhoneNumber: '请输入发送手机号',
      query: '查询',
      sendRecords: '发送记录',
      back: '返回',
      detailId: '明细编号',
      shopName: '店铺名称',
      smsContent: '短信内容',
      phoneNumber: '手机号',
      sendTime: '发送时间',
      phonePlaceholder: '请输入发送手机号'
    }
  }
}